import { Link, useParams } from "react-router-dom";

export const HomeMeetingItem = ({ meeting }) => {
    const { school } = useParams();
    return (
        <div className="slide_item">
            <Link to={`/${school}/meeting?id=${meeting.id}`}>
                <div className="meeting_banner">
                    <img className="cover" src={(null !== meeting.bookImage && meeting.bookImage?.startsWith('http://')) ? `${meeting.bookImage}` : meeting.bookImage} alt="책이랑 나랑" />
                </div>
            </Link>
        </div>
    );
};